import { api } from './client';
export async function getMeetings() {
    return api('/api/meetings');
}
export async function getMeeting(id) {
    return api(`/api/meetings/${id}`);
}
export async function leaveMeeting(meetingId) {
    await api(`/api/meetings/${meetingId}`, { method: 'DELETE' });
}
export async function markRead(meetingId) {
    await api(`/api/meetings/${meetingId}/read`, { method: 'POST' });
}
export async function shareContact(meetingId) {
    await api(`/api/meetings/${meetingId}/share-contact`, { method: 'POST' });
}
export async function extendMeeting(meetingId) {
    await api(`/api/meetings/${meetingId}/extend`, { method: 'POST' });
}
